/* eslint-disable complexity */
import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'
import { Parallax } from 'react-scroll-parallax'

const bem = new BEMHelper('image')

export default function Image({ imageUrl, alt, aspect, spaceless, parallax }) {
  const [w, h] = (aspect || '').split('/')

  return (
    <figure node="figure" {...bem('', { spaceless, parallax })}>
      {parallax ? (
        <Parallax y={[5, -25]} tagOuter="figure">
          <div {...bem('wrapper')}>
            <svg
              viewBox={aspect && w && h ? `0 0 ${w} ${h}` : '0 0 3 2'}
              role="presentation"
              {...bem('aspect')}
            />

            <div {...bem('content')}>
              <div {...bem('image-wrapper')}>
                {imageUrl && (
                  <img src={imageUrl} alt={alt || ''} {...bem('image')} />
                )}
              </div>
            </div>
          </div>
        </Parallax>
      ) : (
        <>
          <div {...bem('wrapper')}>
            <svg
              viewBox={aspect && w && h ? `0 0 ${w} ${h}` : '0 0 3 2'}
              role="presentation"
              {...bem('aspect')}
            />

            <div {...bem('content')}>
              <div {...bem('image-wrapper')}>
                {imageUrl && (
                  <img src={imageUrl} alt={alt || ''} {...bem('image')} />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </figure>
  )
}

Image.propTypes = {
  imageUrl: T.string.isRequired,
  alt: T.string,
  aspect: T.string,
  spaceless: T.bool,
  parallax: T.bool,
}
